import React, {FunctionComponent} from 'react';
import './QuantitiesModifierGroupEdit.less';
import {SelectList} from '../select-list/SelectList';
import {ModifierGroup, ModifierGroupId, ModifierGroupSelections} from '../../../helpers/modifier.helper.types';
import {SelectListItem} from '../select-list-item/SelectListItem';
import {Checkbox} from '../../elements/checkbox/Checkbox';
import {QuantityPicker} from '../quantity-picker/QuantityPicker';
import {convertPrice} from '../../../helpers/format.helper';
import {getModifierSelectionPrice} from '../../../helpers/modifier.helper';

interface QuantitiesModifierGroupEditProps {
	modifierGroup: ModifierGroup,
	modifierGroupSelections: ModifierGroupSelections,
	onModifierChange: (modifierGroupSelections: ModifierGroupSelections, changedModifierGroupId: ModifierGroupId) => void,
	onModifierDescriptionClick: (description: string, event: any) => void
}

const MinimumQuantity = 1;

export const QuantitiesModifierGroupEdit: FunctionComponent<QuantitiesModifierGroupEditProps> = (
	{
		modifierGroup,
		modifierGroupSelections,
		onModifierChange,
		onModifierDescriptionClick,
	}
) => {
	return (<SelectList>
		{
			modifierGroup.modifiers
				.sort((modifier1, modifier2) => modifier1.soldOut ? 1 : (modifier2.soldOut ? -1 : 0))
				.map(modifier => {
					const id = modifier.modifierId;
					const modifierSelection = modifierGroupSelections
						.find(modifierSelection => modifierSelection.modifierId === modifier.modifierId);
					const isSelected = !!modifierSelection;

					const price = getModifierSelectionPrice(modifier, modifierSelection);
					return (
						<SelectListItem
							key={id}
							name={`${modifier.name} ${price > 0 ? '(+' + convertPrice(price) + ')' : ''}`}
							description={modifier.description}
							onDescriptionClick={onModifierDescriptionClick}
							control={<div
								onClick={e => e.stopPropagation()}>
								<QuantityPicker
									value={modifierSelection?.quantity || 0}
									isPressed
									onIncClick={() => {
										const existingSelection = modifierGroupSelections.find(modifierSelection => modifierSelection.modifierId === modifier.modifierId);

										onModifierChange(
											[
												...modifierGroupSelections.filter(modifierSelection => modifierSelection.modifierId !== modifier.modifierId),
												{
													modifierId: modifier.modifierId,
													quantity: existingSelection?.quantity + 1 || MinimumQuantity
												}
											]
											, modifierGroup.modifierGroupId);
									}}
									onDecClick={() => {
										onModifierChange(
											modifierGroupSelections
												.map(modifierSelection => modifierSelection.modifierId === modifier.modifierId
													? {...modifierSelection, quantity: modifierSelection.quantity - 1}
													: modifierSelection)
												.filter(modifierSelection => modifierSelection.quantity > 0)
											, modifierGroup.modifierGroupId);
									}}
								/>
							</div>}
							isSelected={isSelected}
							isDisabled={modifier.soldOut}
						/>
					);
				})
		}
	</SelectList>);
};
